import type { FunctionComponent } from 'react';
import StickyPanel from '@media-ui/core/src/components/StickyPanel';
import StickyGroup from '@media-ui/core/src/components/StickyPanel/StickyGroup';
import StickyItem from '@media-ui/core/src/components/StickyPanel/StickyItem';
import ArticleAside from '@media-ui/pypo-article/src/containers/Article/ArticleAside';
import ArticleCardAnchorMenu from '@media-ui/pypo-article/src/containers/ArticleCard/ArticleCardAnchorMenu';
import { SIDEBAR_OFFSET } from 'Src/constants/';
import type * as T from './types';
const ArticleSidebarCardMenu: FunctionComponent<T.IArticleSidebarProps> = (props) => {
    const { anchors } = props;
    return (<ArticleAside>
      <StickyPanel isCollapsible>
        <StickyGroup topOffset={SIDEBAR_OFFSET.STICKY_GAP_WITH_FIXED_HEADER}>
          <StickyItem hideOrder={10} size={350}>
            <ArticleCardAnchorMenu items={anchors} offsetScroll={SIDEBAR_OFFSET.STICKY_GAP_WITH_FIXED_HEADER} visibleItemsCount={5}/>
          </StickyItem>
        </StickyGroup>
      </StickyPanel>
    </ArticleAside>);
};
export default ArticleSidebarCardMenu;
